module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper career-page-wrapper expert-page-wrapper",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [(_vm.getExpert && _vm.expertInfo) ? _c('div', {
    staticClass: "featured main"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row margin-top-40"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.expertInfo.large_image,
      "alt": _vm.expertInfo.name,
      "title": _vm.expertInfo.name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "experts"
  }, [_c('h2', [_vm._v("\n                                    " + _vm._s(_vm.expertInfo.name) + "\n                                ")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("\n                                    (" + _vm._s(_vm.expertInfo.experties) + ")\n                                ")]), _vm._v(" "), _c('p', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.expertInfo.biography)
    }
  })])])])])])]) : _vm._e(), _vm._v(" "), (_vm.expertEvent) ? _c('div', {
    staticClass: "live-chat"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', {
    staticClass: "live-chat-heading pinkh2",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Upcoming "), (_vm.expertEvent.type === '1') ? _c('span', [_vm._v("TONE Live")]) : _c('span', [_vm._v("TONE Talk")]), _vm._v(" Event")])]), _vm._v(" "), (_vm.expertEvent && _vm.showJoin(_vm.expertEvent)) ? _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [(_vm.expertEvent) ? _c('rulescomp', {
    style: ({
      border: '1px solid ' + _vm.getCorpHeaderColor
    }),
    attrs: {
      "data": _vm.expertEvent
    }
  }, [_vm._v("Loading event rules")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row margin-top-40"
  }, [(_vm.getExpert) ? _c('div', {
    staticClass: "col-md-6 col-md-offset-1"
  }, [_c('img', {
    attrs: {
      "src": _vm.expertEvent.img_url,
      "alt": "EVENT BANNER",
      "title": _vm.expertEvent.title
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.getExpert && _vm.expertInfo) ? _c('div', {
    staticClass: "experts"
  }, [_c('h2', [_vm._v("\n                                    Join an Exclusive "), (_vm.expertEvent.type === '1') ? _c('span', [_vm._v("TONE Live")]) : _c('span', [_vm._v("TONE Talk")]), _vm._v(" Event with " + _vm._s(_vm.replaceLastExpert(_vm.expertEvent.csvExpertsNames, ',', ' & ')) + "\n                                ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    " + _vm._s(_vm.expertEvent.longDescription) + "\n                                ")]), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v("\n                                    " + _vm._s(_vm.getDateReference(_vm.expertEvent.start_date, 'str')) + "\n                                ")]), _vm._v(" "), (!_vm.showJoin(_vm.expertEvent)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    }
  }, [_vm._v("\n                                    Add to Calendar\n                                    "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.expertEvent.start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.expertEvent.end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.expertEvent.title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.expertEvent.longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.expertEvent.type === '1') ? _c('span', [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.expertEvent.eventId))]) : _c('span', [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.expertEvent.eventId))])])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCorporateImageShareModal(_vm.expertEvent)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share\n                                ")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.expertEvent && !_vm.showJoin(_vm.expertEvent)) ? _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [(_vm.expertEvent) ? _c('rulescomp', {
    style: ({
      border: '1px solid ' + _vm.getCorpHeaderColor
    }),
    attrs: {
      "data": _vm.expertEvent
    }
  }, [_vm._v("Loading event rules")]) : _vm._e()], 1) : _vm._e()])])]) : _c('div', {
    staticClass: "container"
  }, [(_vm.getExpertVideos) ? _c('div', {
    staticClass: "row"
  }, [(_vm.getExpert && _vm.expertMainVideo && _vm.expertInfo) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', {
    staticClass: "pinkh2",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("MEET " + _vm._s(_vm.expertInfo.name))])]) : _vm._e(), _vm._v(" "), (_vm.expertMainVideo) ? _c('div', {
    staticClass: "col-sm-6 col-sm-offset-3"
  }, [_c('jwplayer', {
    attrs: {
      "id": "expertMainVid",
      "data": _vm.expertMainVideo
    }
  }, [_vm._v("Loading the player...")]), _vm._v(" "), _c('h3', [_c('i', {
    staticClass: "fa fa-play"
  }), _vm._v(" " + _vm._s(_vm.expertMainVideo.title))])], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.getExpertVideos) ? _c('div', {
    staticClass: "random"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "margin-top-40"
  }, [_c('div', {
    staticClass: "blog-section videossection clearfix"
  }, [(_vm.getExpert) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 margin-bottom-40"
  }, [_c('h2', {
    staticClass: "text-center pinkh2",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("MOST POPULAR VIDEOS FROM " + _vm._s(_vm.expertInfo.name))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row random-section-head yourFaves exceptionalsettings"
  }, [(_vm.getExpertVideos[1]) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
    class: {
      'innerimggray': _vm.getTrialDays < 0
    }
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getExpertVideos[1].mediaid + '/' + _vm.getExpertVideos[1].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.getExpertVideos[1].image,
      "alt": _vm.getExpertVideos[1].title,
      "title": _vm.getExpertVideos[1].title
    }
  }), _vm._v(" "), (_vm.getExpertVideos[1].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _c('strong', [_vm._v(_vm._s(_vm.getExpertVideos[1].title))])]) : _vm._e(), _vm._v(" "), (!_vm.getExpertVideos[1].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(_vm._s(_vm.getExpertVideos[1].title))]) : _vm._e()]), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[1].marketing) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[1].marketing) ? _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": _vm.getExpertVideos[1].mediaid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu(_vm.getExpertVideos[1].mediaid)
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getExpertVideos[1])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getExpertVideos[1], playlist, _vm.verifyVideoExists(playlist, _vm.getExpertVideos[1]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                            "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[1].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
      staticClass: "added"
    }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[1].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu(_vm.getExpertVideos[1].mediaid)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[1].marketing) ? _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getExpertVideos[1])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getExpertVideos[1])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getExpertVideos[4]) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
    class: {
      'innerimggray': _vm.getTrialDays < 0
    }
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getExpertVideos[4].mediaid + '/' + _vm.getExpertVideos[4].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.getExpertVideos[4].image,
      "alt": _vm.getExpertVideos[4].title,
      "title": _vm.getExpertVideos[4].title
    }
  }), _vm._v(" "), (_vm.getExpertVideos[4].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _c('strong', [_vm._v(_vm._s(_vm.getExpertVideos[4].title))])]) : _vm._e(), _vm._v(" "), (!_vm.getExpertVideos[4].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(_vm._s(_vm.getExpertVideos[4].title))]) : _vm._e()]), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[4].marketing) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[4].marketing) ? _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": _vm.getExpertVideos[4].mediaid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu(_vm.getExpertVideos[4].mediaid)
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getExpertVideos[4])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getExpertVideos[4], playlist, _vm.verifyVideoExists(playlist, _vm.getExpertVideos[4]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                            "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[4].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
      staticClass: "added"
    }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[4].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu(_vm.getExpertVideos[4].mediaid)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[4].marketing) ? _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getExpertVideos[4])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getExpertVideos[4])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getExpertVideos[2]) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
    class: {
      'innerimggray': _vm.getTrialDays < 0
    }
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getExpertVideos[2].mediaid + '/' + _vm.getExpertVideos[2].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.getExpertVideos[2].image,
      "alt": _vm.getExpertVideos[2].title,
      "title": _vm.getExpertVideos[2].title
    }
  }), _vm._v(" "), (_vm.getExpertVideos[2].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _c('strong', [_vm._v(_vm._s(_vm.getExpertVideos[2].title))])]) : _vm._e(), _vm._v(" "), (!_vm.getExpertVideos[2].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(_vm._s(_vm.getExpertVideos[2].title))]) : _vm._e()]), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[2].marketing) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[2].marketing) ? _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": _vm.getExpertVideos[2].mediaid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu(_vm.getExpertVideos[2].mediaid)
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getExpertVideos[2])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getExpertVideos[2], playlist, _vm.verifyVideoExists(playlist, _vm.getExpertVideos[2]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[2].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
      staticClass: "added"
    }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[2].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu(_vm.getExpertVideos[2].mediaid)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[2].marketing) ? _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getExpertVideos[2])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getExpertVideos[2])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getExpertVideos[5]) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
    class: {
      'innerimggray': _vm.getTrialDays < 0
    }
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getExpertVideos[5].mediaid + '/' + _vm.getExpertVideos[5].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.getExpertVideos[5].image,
      "alt": _vm.getExpertVideos[5].title,
      "title": _vm.getExpertVideos[5].title
    }
  }), _vm._v(" "), (_vm.getExpertVideos[5].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _c('strong', [_vm._v(_vm._s(_vm.getExpertVideos[5].title))])]) : _vm._e(), _vm._v(" "), (!_vm.getExpertVideos[5].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(_vm._s(_vm.getExpertVideos[5].title))]) : _vm._e()]), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[5].marketing) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[5].marketing) ? _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": _vm.getExpertVideos[5].mediaid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu(_vm.getExpertVideos[5].mediaid)
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getExpertVideos[5])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getExpertVideos[5], playlist, _vm.verifyVideoExists(playlist, _vm.getExpertVideos[5]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                            "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[5].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
      staticClass: "added"
    }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[5].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu(_vm.getExpertVideos[5].mediaid)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[5].marketing) ? _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getExpertVideos[5])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getExpertVideos[5])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getExpertVideos[3]) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
    class: {
      'innerimggray': _vm.getTrialDays < 0
    }
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getExpertVideos[3].mediaid + '/' + _vm.getExpertVideos[3].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.getExpertVideos[3].image,
      "alt": _vm.getExpertVideos[3].title,
      "title": _vm.getExpertVideos[3].title
    }
  }), _vm._v(" "), (_vm.getExpertVideos[3].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _c('strong', [_vm._v(_vm._s(_vm.getExpertVideos[3].title))])]) : _vm._e(), _vm._v(" "), (!_vm.getExpertVideos[3].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(_vm._s(_vm.getExpertVideos[3].title))]) : _vm._e()]), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[3].marketing) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[3].marketing) ? _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": _vm.getExpertVideos[3].mediaid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu(_vm.getExpertVideos[3].mediaid)
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(8)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getExpertVideos[3])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getExpertVideos[3], playlist, _vm.verifyVideoExists(playlist, _vm.getExpertVideos[3]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[3].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
      staticClass: "added"
    }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[3].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu(_vm.getExpertVideos[5].mediaid)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[3].marketing) ? _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getExpertVideos[3])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getExpertVideos[3])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getExpertVideos[6]) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
    class: {
      'innerimggray': _vm.getTrialDays < 0
    }
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getExpertVideos[6].mediaid + '/' + _vm.getExpertVideos[6].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.getExpertVideos[6].image,
      "alt": _vm.getExpertVideos[6].title,
      "title": _vm.getExpertVideos[6].title
    }
  }), _vm._v(" "), (_vm.getExpertVideos[6].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _c('strong', [_vm._v(_vm._s(_vm.getExpertVideos[6].title))])]) : _vm._e(), _vm._v(" "), (!_vm.getExpertVideos[6].marketing) ? _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(_vm._s(_vm.getExpertVideos[6].title))]) : _vm._e()]), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[6].marketing) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[6].marketing) ? _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": _vm.getExpertVideos[6].mediaid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu(_vm.getExpertVideos[6].mediaid)
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(10)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getExpertVideos[6])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getExpertVideos[6], playlist, _vm.verifyVideoExists(playlist, _vm.getExpertVideos[6]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[6].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
      staticClass: "added"
    }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.getExpertVideos[6].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu(_vm.getExpertVideos[6].mediaid)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.getExpertVideos[6].marketing) ? _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getExpertVideos[6])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getExpertVideos[6])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), (!_vm.getVideosFlag) ? _c('div', {
    staticClass: "pintlist-holder"
  }, [(_vm.expertInfo) ? _c('h2', {
    staticClass: "pinkh2",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("browse all of " + _vm._s(_vm.expertInfo.name) + "'s videos")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: true
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [_c('div', {}, [(_vm.getExpertPlaylist) ? _c('div', {
    staticClass: "row yourFaves"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _vm._l((_vm.getExpertPlaylist), function(video) {
    return (!_vm.verifyVideoStatus(video.mediaid)) ? _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      }
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(video.title))])]), _vm._v(" "), (_vm.user) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.user) ? _c('div', {
      staticClass: "plusicon btn-group"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "title": "Add to Playlist",
        "id": video.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(video.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(12, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, video)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(video, playlist, _vm.verifyVideoExists(playlist, video))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(13, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(video.mediaid)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(video)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(video)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()]) : _vm._e()
  })], 2) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.expertInfo && _vm.getExpertArchiveClips && _vm.user) ? _c('div', {
    staticClass: "pintlist-holder"
  }, [(_vm.expertInfo) ? _c('h2', {
    staticClass: "pinkh2",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("TONE Coaching Tips")]) : _vm._e(), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: true
    },
    attrs: {
      "id": "tabs-5"
    }
  }, [_c('div', {}, [(_vm.getExpertArchiveClips) ? _c('div', {
    staticClass: "row yourFaves"
  }, _vm._l((_vm.getExpertArchiveClips), function(evn) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      },
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('div', {
      staticClass: "show-share-options"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": evn.img_url,
        "alt": "ARCHIVE EVENT BANNER",
        "title": evn.title
      },
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }), _c('div', {
      staticClass: "favnumbers",
      style: ({
        backgroundColor: _vm.getCorpHeaderColor
      })
    }, [_c('div', [_c('span', [_vm._v(_vm._s(evn.allVidDurInMinutes)), _c('small', [_vm._v("mins")])])]), _c('i', {
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "title": "Play"
      },
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }), (((_vm.user && _vm.user.corporation === null) || (_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.shareExpertCoachingTipPermission >= 1))) ? _c('i', {
      staticClass: "fa fa-share-square-o",
      attrs: {
        "title": "Share Playlist"
      },
      on: {
        "click": function($event) {
          return _vm.showSharingModal(evn)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('h2', {
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }, [_vm._v(_vm._s(evn.title))]), _vm._v(" "), _c('p', {
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(evn.longDescription) + "\n\n                            ")])])
  }), 0) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.showWatchVideoModal) ? _c('modal', {
    staticClass: "watchVideoModal",
    attrs: {
      "effect": "zoom",
      "value": _vm.showWatchVideoModal
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.svg"),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('jwplayer', {
    attrs: {
      "data": _vm.currentPlayerID
    }
  }, [_vm._v("Loading the player...")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.currentPlayerID.videoDescription) + "\n                ")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showSharedModal) ? _c('modal', {
    staticClass: "watchVideoModal",
    attrs: {
      "effect": "zoom",
      "value": _vm.showSharedModal
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelEmailShareModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.svg"),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelEmailShareModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "method": "post",
      "id": "playlistshare-form",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSharePlaylist.apply(null, arguments)
      }
    }
  }, [_c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "name": "playlistshare_sharedMessage",
      "id": "playlistshare_sharedMessage",
      "type": "text",
      "error": "Optional Message",
      "placeholder": "Optional Message",
      "autocomplete": "off",
      "icon": ""
    },
    model: {
      value: (_vm.sharePayload.sharedEmailMessage),
      callback: function($$v) {
        _vm.$set(_vm.sharePayload, "sharedEmailMessage", $$v)
      },
      expression: "sharePayload.sharedEmailMessage"
    }
  }), _vm._v(" "), _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "name": "playlistshare_sharedEmailMessagePreview",
      "id": "playlistshare_sharedEmailMessagePreview",
      "type": "textarea",
      "disabled": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.sharePayload.sharedPlaylistPreview),
      callback: function($$v) {
        _vm.$set(_vm.sharePayload, "sharedPlaylistPreview", $$v)
      },
      expression: "sharePayload.sharedPlaylistPreview"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "submit",
      "disabled": _vm.spinner || (_vm.taggedEmails && _vm.taggedEmails.length === 0)
    }
  }, [_vm._v("\n                            Send Email\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showCorporateShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.showShareCommunity) ? _c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]) : _vm._e(), _vm._v(" "), (_vm.showShareIndividual) ? _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]) : _vm._e(), _vm._v(" "), (_vm.showShareFriends) ? _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")]) : _vm._e()])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.corpShareModalImage,
      "alt": _vm.corpShareModalTitle,
      "title": _vm.corpShareModalTitle
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s((_vm.corpShareModalTitle + " | TONE Networks")))]), _vm._v(" "), (_vm.corpShareModalDesc) ? _c('p', [_vm._v(" " + _vm._s(((_vm.corpShareModalDesc.substring(0,250)) + "...")))]) : _vm._e(), _vm._v(" "), (!_vm.corpShareModalDesc) ? _c('p', [_vm._v(_vm._s(_vm.user.firstName) + "'s Personal Playlist")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess))
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateVideo()
      }
    }
  }, [_vm._v("\n                            Share This Playlist\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showCorporateImageShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateImageShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")])])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.shareEventSelected.img_url,
      "alt": _vm.shareEventSelected.title,
      "title": _vm.shareEventSelected.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(((_vm.shareEventSelected.title) + " | TONE Networks")))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(((_vm.shareEventSelected.longDescription.substring(0,250)) + "...")))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess))
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateImage()
      }
    }
  }, [_vm._v("\n                            Share This Event\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
}]}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e3f93fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_live_NgwNoBs3GAlrsSez07Zyh4Jc"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www.tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/assets.tonenetworks.com/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/Expert.vue